import React from 'react';
import styled from 'styled-components';

export const UnhandledTypeSlide = ({ data }) => {
  const { currentStep } = data;

  console.error('Unhandled step type: ', currentStep?.type);
  return (
    <Wrapper>
      <h1>Unhandled step</h1>
    </Wrapper>
  );
};

export const Wrapper = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
